(() => {
    const popupBanner = document.getElementById('popup-banner')

    const popupToggle = popupBanner
        && popupBanner
            .querySelector('summary')

    const popupClone = popupBanner
        && popupBanner.cloneNode(true)

    if (!popupToggle || !popupClone)
        return

    Array.from(popupClone.querySelectorAll('[id], [aria-describedby]'))
        .concat([popupClone])
        .forEach(el => {
            el.removeAttribute('id')
            el.removeAttribute('aria-describedby')
        })

    Array.from(['data-aos', 'data-aos-duration', 'data-aos-delay'])
        .forEach(attr => popupClone.removeAttribute(attr))

    popupClone.classList
        .add('popup-banner-clone')

    popupClone
        .setAttribute('aria-hidden', true)

    const popupCloneDetails = popupClone
        .querySelector('details')

    if (popupCloneDetails)
        popupCloneDetails.open = true

    document.body
        .appendChild(popupClone)

    const popupCloneContent = popupClone
        .querySelector('.popup-banner-content')

    const getPopupMinHeight = (open) => popupCloneDetails
        && popupCloneContent
        && `${popupCloneDetails.clientHeight
                - (!open
                    ? popupCloneContent.clientHeight
                    : 0)}px`

    const setCssVar = (name, val, el) => name
        && (el || document.documentElement).style
            .setProperty(name, val || '')

    setCssVar('--popup-banner-height', `${popupClone.clientHeight}px`)

    popupToggle
        .addEventListener('click', (e) => {
            if (!popupBanner
                    || !popupBanner.children[0])
                return

            e.preventDefault()
            e.stopPropagation()

            if (popupBanner.getAttribute('data-toggling'))
                return

            popupBanner.setAttribute('data-toggling', true)

            const setMinHeight = (
                minHeight = getPopupMinHeight(!popupToggle.parentElement.open)
            ) =>
                (popupBanner.children[0].style.minHeight = minHeight)

            setMinHeight(`${popupBanner.children[0].clientHeight}px`)

            const toggleOpen = () =>
                (popupToggle.parentElement.open
                    = !popupToggle.parentElement.open)

            if (!popupToggle.parentElement.open) {
                popupBanner.setAttribute('data-opening', true)

                const onContainerTransitionEnd = (e) => {
                    popupBanner.children[0]
                        .removeEventListener('transitionend',
                            onContainerTransitionEnd)

                    toggleOpen()

                    popupBanner.removeAttribute('data-toggling')

                    setTimeout(() =>
                        popupBanner.removeAttribute('data-opening'), 17)
                }

                popupBanner.children[0]
                    .addEventListener('transitionend',
                        onContainerTransitionEnd)

                const openMinHeight = getPopupMinHeight(true)

                setCssVar('--popup-banner-height', openMinHeight)

                return setMinHeight(openMinHeight)
            }

            if (popupToggle.parentElement.open) {
                const popupContent = popupBanner
                    .querySelector('.popup-banner-content')

                const closeMinHeight = getPopupMinHeight(false)

                if (!popupContent) {
                    toggleOpen()

                    popupBanner
                        .removeAttribute('data-toggling')

                    setCssVar('--popup-banner-height',
                        `${closeMinHeight}`)

                    setMinHeight(closeMinHeight)
                }

                const onContentTransitionEnd = (e) => {
                    popupContent
                        .removeEventListener('transitionend',
                            onContentTransitionEnd)

                    popupBanner
                        .removeAttribute('data-closing')

                    toggleOpen()

                    setCssVar('--popup-banner-height',
                        `${closeMinHeight}`)

                    setMinHeight(closeMinHeight)

                    popupBanner
                        .removeAttribute('data-toggling')
                }

                popupContent
                    .addEventListener('transitionend',
                        onContentTransitionEnd)

                popupBanner
                    .setAttribute('data-closing', true)
            }
        })

    let resizeDebounce

    window.addEventListener('resize', (e) => {
        if ((popupBanner || {}).children[0]
                && popupBanner.children[0].style.minHeight)
            popupBanner.children[0].style.minHeight = ''

        if (resizeDebounce)
            clearTimeout(resizeDebounce)

        resizeDebounce = setTimeout(() => popupToggle
            && setCssVar('--popup-banner-height',
                getPopupMinHeight(popupToggle.parentElement.open)), 200)
    })
})()
